"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_jss_1 = require("react-jss");
exports.useStyles = (0, react_jss_1.createUseStyles)({
    component: {},
    headline: {},
    beforeInput: {},
    afterInput: {},
    input: {
        maxWidth: 50,
    },
    list: {}
});
